import { createLoader } from '@meteor/data-hooks';
import { autoPaginate, withManagementSDK } from '../../management';

export let policiesLoader = createLoader({
  name: 'policies',
  fetch: (i: { instanceId: string }) =>
    withManagementSDK(i, sdk =>
      autoPaginate(pag => sdk.instances.policies.list(i.instanceId, pag))
    ),
  mutators: {
    create: (i: { name: string; slug: string; description: string }, { input }) =>
      withManagementSDK(input, sdk => sdk.instances.policies.create(input.instanceId, i))
  }
});

export let usePolicies = (instanceId: string | null) => {
  let policies = policiesLoader.use(instanceId ? { instanceId } : null);

  return {
    ...policies,
    createMutator: policies.useMutator('create')
  };
};

export let policyLoader = createLoader({
  name: 'policy',
  fetch: (i: { instanceId: string; policyId: string }) =>
    withManagementSDK(i, sdk => sdk.instances.policies.get(i.instanceId, i.policyId)),
  mutators: {
    update: (i: {
      policyId: string;
      instanceId: string;
      name?: string;
      slug?: string;
      description?: string;
      isDefault?: boolean;
    }) =>
      withManagementSDK(i, sdk => sdk.instances.policies.update(i.instanceId, i.policyId, i))
  }
});

export let usePolicy = (policyId: string | null, instanceId: string | null) => {
  let policy = policyLoader.use(policyId && instanceId ? { policyId, instanceId } : null);

  return {
    ...policy,
    updateMutator: policy.useMutator('update')
  };
};
